
<template>
  <v-app id="searchNttp">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Booking statuses (You Should Ask)</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(hustRecord,i) in searchHust" :key="i">
           <tr @click="$router.reload('/syst/ref/hust/onHust/' + hustRecord.hust_encrid)">
             <td>{{hustRecord.hust_code}}</td>
             <td>{{hustRecord.husttaal_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>   
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchHust: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/hust/searchHust.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHust"
          },
          searchHust: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchHust = res.data.searchHust;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
